// import homeSmartphoneImg from '../../assets/mobile/home-smartphone.png';
// import homeLaptopImg from '../../assets/desktop/home-laptop.png';
// import homeLaptop2Img from '../../assets/desktop/home-laptop2.png';

interface HeroProps {
  scrollToSection: (sectionId: string, text?: string) => void;
}


const Hero: React.FC<HeroProps> = ({ scrollToSection }) => {
  const sendToContact = () => {
    const message = 'Olá, quero saber mais detalhes sobre o Menu Master.';
    scrollToSection('contato', message)
  }

  // const homeStyleDiv = {
  //   alignItems: 'center'
  // }
  // const imgLaptopStyle = {
  //   width: '100rem',
  //   height: '20rem'
  // }
  // const imgMobileStyle = {
  //   width: 'auto',
  //   height: '30rem'
  // }

  return (
    <section id="inicio" className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-orange-50 to-amber-50">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
          Transforme a gestão do seu <span className="text-orange-500">restaurante</span>
        </h1>
        <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
          Sistema completo para gerenciar pedidos, mesas, estoque e delivery.
          Controle total do seu negócio em uma única plataforma.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={sendToContact}
            className="bg-orange-500 text-white px-8 py-4 rounded-lg hover:bg-orange-600 transition font-medium text-lg shadow-lg hover:shadow-xl flex items-center gap-2"
          >
            Começar agora
            {/* Teste Grátis por 14 dias */}
            {/* <ChevronRight className="w-5 h-5" /> */}
          </button>
          <button
            onClick={() => scrollToSection('recursos')}
            className="bg-white text-orange-500 border-2 border-orange-500 px-8 py-4 rounded-lg hover:bg-orange-50 transition font-medium text-lg"
          >
            Ver Recursos
          </button>
        </div>

        <div className="mt-16 bg-white rounded-2xl shadow-2xl p-4 max-w-4xl mx-auto flex">
          <img
            src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1200&h=600&fit=crop"
            alt="Dashboard Preview"
            className="rounded-lg w-full"
          />
        </div>
        {/* <div className="mt-16 rounded-2xl p-4 max-w-4xl mx-auto flex" style={homeStyleDiv}>
          <img
            src={homeLaptopImg}
            alt="Home Laptop Preview"
            className=""
            style={imgLaptopStyle}
          />
          <img
            src={homeSmartphoneImg}
            alt="Home Mobile Preview"
            className=""
            style={imgMobileStyle}
          />
        </div> */}
      </div>
    </section>
  );
}

export default Hero;